import { PresetData } from '@/api/apiClient';

/**
 * Get preset name safely from presetsData
 * Similar to getPresetNameSafe from original app
 */
export function getPresetNameSafe(
  path: string,
  value: string,
  presetsData: PresetData | null
): string {
  if (!presetsData || !value) return '-';

  try {
    const pathParts = path.split('.');
    let current: any = presetsData;

    for (const part of pathParts) {
      if (current && typeof current === 'object' && part in current) {
        current = current[part];
      } else {
        return value; // Return raw value if path not found
      }
    }

    if (current && typeof current === 'object' && value in current) {
      const preset = current[value];
      if (preset && typeof preset === 'object' && 'name' in preset) {
        return preset.name as string;
      }
    }

    return value; // Return raw value if not found
  } catch (error) {
    console.error('[PresetHelper] Error getting preset name:', error);
    return value;
  }
}
